module.exports = __webpack_public_path__ + "img/en-GB-add-to-google-wallet.d6395ad.svg";